import { useEffect, useState } from 'react'
import CancelableAPIRequest from 'src/models/CancelableAPIRequest'
import { ItemPage } from 'src/pages/menu/Item'
import { useAuthState } from 'src/providers/AuthProviders'
import getItemRollUser from 'src/services/get/getItemRoll'
import getUserItems from 'src/services/get/getUserItems'
import getUserMaterialItems from 'src/services/get/getUserMaterialItems'
import { materialCategories } from 'src/pages/main/house/const/houseConstants'

const ItemPageContainer = () => {
  const [items, setItems] = useState([])
  const [itemSpecial, setItemSpecial] = useState([])
  const [itemMaterial, setItemMaterial] = useState([])
  const [specialLoaded, setSpecialLoaded] = useState(false)
  const [historyLoaded, setHistoryLoaded] = useState(false)
  const [materialLoaded, setMaterialLoaded] = useState(false)
  const isLoading = !specialLoaded || !historyLoaded || !materialLoaded

  const { user } = useAuthState()

  useEffect(() => {
    if (!user?.id) return

    const req = new CancelableAPIRequest(getUserItems, user.id)

    req.invoke((res) => {
      if (res.length !== 0) setItemSpecial([...res])
      setSpecialLoaded(true)
    })

    return () => {
      req.cancel()
    }
  }, [user?.id])

  useEffect(() => {
    if (!user?.id) return

    const loadItemHistory = async () => {
      try {
        const response = await getItemRollUser(user.id)
        setItems(response.items)
      } catch (error) {
        console.error(error)
      } finally {
        setHistoryLoaded(true)
      }
    }

    loadItemHistory()
  }, [user?.id])

  useEffect(() => {
    if (!user?.id) return

    const loadItemMaterial = async () => {
      try {
        const response = await getUserMaterialItems()
        setItemMaterial([...response.items])
      } catch (error) {
        console.error(error)
      } finally {
        setMaterialLoaded(true)
      }
    }

    loadItemMaterial()
  }, [user?.id])

  return (
    <ItemPage
      itemsHistory={items}
      isLoading={isLoading}
      itemSpecial={itemSpecial}
      itemMaterial={itemMaterial}
      materialCategories={materialCategories}
    />
  )
}

export default ItemPageContainer
